// OptionDetailsListItemAdd.js

export default function OptionDetailsListItemAdd(P_OptionDetailsListItem){
    // P_OptionDetailsListItem.Currency = 'HKD';
    P_OptionDetailsListItem.Status = 'Pending';
    P_OptionDetailsListItem.Expired = false;
    P_OptionDetailsListItem.RefCostPrice = null; // When moving the GroupNumberListItem from OptionTable to MyList, only RefCostContract, RefCostShare, RefValueContract and RefValueShare are updated because RefCostPrice and RefValuePrice may be changed many times within 1 second
    P_OptionDetailsListItem.RefValuePrice = null;
}